import * as React from 'react'
import Spin from '@components/Spin'
import { observer, inject } from 'mobx-react'
import { withStyles, WithStyles } from '@zn-material-ui'
import Store from 'store'
import _ from 'lodash'
import qs from 'qs'
import { MD5 } from '@utils/lib'
import { validateEmail } from '@utils'
import UserStore from '@stores/UserStore'
import oneLogin from '@assets/images/login/one_login.png'
import enterpriseLogin from '@assets/images/login/enterprise-login.png'
import { b64Decode } from '@utils/lib'
import { rsaEncodeString } from '@utils'
import AdornedButton from '@components/AdornedButton'
import ConfirmDialog from '@components/Dialog'
import SliderCaptcha, { SuccessType, CaptchaType } from '@components/SliderCaptcha'
import { News as Setting, Login } from '@services/api'
import { isSpecifiedType } from '@services/api/Login'
import LoginHelper from './LoginHelper'
import NormalLogin from './NormalLogin'
import EnterpriseLogin from './EnterpriseLogin'
import FreeLogin from './FreeLogin'
import PasswordLogin from './PasswordLogin'
import CaptchaImgDialog from './CaptchaImgDialog'
import LeftLogo from './LeftLogo'
import LoginTab, { LoginTabEnum } from './LoginTab'
import AgreementForLogin from './AgreementForLogin'
import loginStyles from '../Login/styles/LoginFormStyle'
import { IProps as ILoginProps } from '../Login/index'
import {
  IAppItem,
  IIdentytyItem,
  LoginBodyCodeEnum,
  CaptEnum,
  SlideParamsType,
} from '../Login/type'
import {
  passSeperator,
  isEqualFakePwd,
  rememberPwd,
  queryOperationList,
  getHomeList,
  deletePwd,
  initialState,
  hideGeetestPopup,
} from '../Login/helper'
import SwitchLanguage from '@components/SwitchLanguage'
import { transform } from '@utils/intl_lang'

export interface IProps extends ILoginProps, WithStyles<typeof loginStyles> {}

interface IState extends Readonly<typeof initialState> {
  [key: string]: any
}

@inject('UserStore', 'AppStore')
@observer
class LoginForm extends React.Component<IProps, IState> {
  public state = initialState
  private sliderParams = {} as SlideParamsType
  private captchaObj = null as CaptchaType | null
  private isTopUpType = false
  private isOpenPlatformLogin = false
  private notHomeListType = true
  private isOpenPlatform = '0'
  constructor(props: IProps) {
    super(props)
    // 运营人员充值模式
    this.isTopUpType = isSpecifiedType('/mili-top-up')
    // 开放平台模式
    this.isOpenPlatformLogin = isSpecifiedType(
      '/admin/openPlatform/developer-auth'
    )
    this.notHomeListType = this.isOpenPlatformLogin || this.isTopUpType
    this.isOpenPlatform = this.isOpenPlatformLogin ? '1' : '0'
    Store.set('isSingleLogin', false)
    Store.set('isOpenPlatform', this.isOpenPlatform)
    if (this.notHomeListType) {
      Store.remove('homeId')
      Store.remove('isPcOpen')
    }
  }

  public componentDidMount() {
    document.addEventListener('mousedown', this.handleClick as any)
    this.loginFromKX()
    // 企业代码
    const enterpriseCode = Store.get('enterpriseCode')
    let passwordInfo = Store.get('passwordInfo')
    if (enterpriseCode) {
      this.setState(
        {
          enterpriseCode
        })
    }
    if (!passwordInfo || !(typeof passwordInfo === 'string')) {
      Store.set('passwordInfo', '')
      return
    }
    passwordInfo = b64Decode(passwordInfo)
    passwordInfo = passwordInfo.split(passSeperator)
    const [username, password, length] = passwordInfo
    // 之前的处理逻辑没有存储长度（最少长度为8），此字段值小于8则判断为旧逻辑，重新存储账密
    if (isNaN(+length) || length < 8) {
      Store.set('passwordInfo', '')
      return
    }
    if (passwordInfo) {
      this.setState(
        {
          username,
          password: new Array(+length).fill('*').join(''),
          initialPwd: password,
          rememberPwd: true,
        }
      )
    }
  }

  // 中车智门户统一登录
  loginFromKX = async () => {
    const { code = '', state = '' } = qs.parse(window.location.hash.split('?')[1])
    if (!code || !state) {
      return
    }
    this.setState({ loadingFirst: true })
    const res = await Login.KXLogin({ code, state })
    this.setState({ loadingFirst: false })
    if (res.code !== 0) {
      global.$message(res.message)
      return
    }
    const { bodyCode, bodyMsg, sid, userId, appId, enterpriseId, enterpriseName } = res.body
    const appIdKX = appId || 'com.mlearning.guangqichuanqi' // 更新appId
    const loginSuccess =
      bodyCode === LoginBodyCodeEnum.VALID ||
      bodyCode === LoginBodyCodeEnum.VALID_WITH_NOT_IDENTITY
    if (loginSuccess) {
      UserStore.updateLoginInfo(enterpriseId, enterpriseName, sid, userId, appIdKX)
      Store.set('mobilePhone', res.mobilePhone)
      setTimeout(() => {
        if (!this.notHomeListType) {
          queryOperationList()
        }
        const { history, AppStore } = this.props
        getHomeList({ history, AppStore }, this.notHomeListType)
      })
      return
    }
    // 登录失败跳到统一登录页
    global.$message(bodyMsg)
    setTimeout(() => {
      this.props.history.push('/sifang-login')
    }, 1000)
  }

  public handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    // 关闭验证码弹窗
    hideGeetestPopup(this.captchaObj, e.target)
  }
  // 验证码通过
  public onCaptSuccess = (success: SuccessType) => {
    if (success) {
      const {
        geetest_challenge: slideChallenge,
        geetest_seccode: slideSecCode,
        geetest_validate: slideValidate,
      } = success
      let type = CaptEnum.NORMAL_LOGIN as string
      if (this.isTopUpType) {
        type = '204'
      } else if (this.isOpenPlatformLogin) {
        type = '203'
      }
      this.sliderParams = {
        isSlideValidate: 'true',
        slideChallenge,
        slideSecCode,
        slideValidate,
        type,
      }
      const loginType = this.state.loginType
      const { isPasswordType, isEnterpriseShow } = this.state
      if (loginType === LoginTabEnum.FREE_LOGIN && !isPasswordType) {
        this.sendVerCodeCaptcha(success)
        return
      }
      if ((loginType === LoginTabEnum.FREE_LOGIN && isPasswordType) || loginType === LoginTabEnum.NORMAL_LOGIN) {
        this.loginAppAndCompany()
        return
      }
      if (isEnterpriseShow && loginType === LoginTabEnum.ENTERPRISE_LOGIN) {
        this.onEnterpriseLogin()
        return
      }
    }
  }

  public onCaptInit = (captchaObj: CaptchaType | null) => {
    this.setState({ slideVisible: !!captchaObj })
    this.captchaObj = captchaObj
  }

  handleBack = () => {
    const { stepOne } = this.state
    if (!stepOne) {
      this.setState({ stepOne: true })
    } else {
      this.setState({
        isEnterpriseShow: false,
        checkAgreement: false,
        isPasswordType: true,
        loginType: LoginTabEnum.FREE_LOGIN,
        password: ''
      })
    }
  }

  // 图形验证码关闭
  onImgClose = () => {
    this.setState({ imgVisible: false })
  }

  // 图形验证码确认
  captchaPass = () => {
    this.setState({ imgVisible: false })
    const loginType = this.state.loginType
    const { isPasswordType, isEnterpriseShow } = this.state
    if (loginType === LoginTabEnum.FREE_LOGIN && !isPasswordType) {
      this.handlePassOk()
      return
    }
    if ((loginType === LoginTabEnum.FREE_LOGIN && isPasswordType) || loginType === LoginTabEnum.NORMAL_LOGIN) {
      this.loginAppAndCompany()
      return
    }
    if (isEnterpriseShow && loginType === LoginTabEnum.ENTERPRISE_LOGIN) {
      this.onEnterpriseLogin()
      return
    }
  }

  handleImgCaptchaChange = (event: any) => {
    this.setState({ imgCaptcha: event.target.value} )
  }

  // 登录方式切换
  changeEmpLogin = (isPasswordType: boolean) => {
    if (isPasswordType) {
      this.setState({ password: '' })
    } else {
      this.setState({ captcha: '' })
    }
    this.setState({ isPasswordType })
  }

  sendVerCodeCaptcha = async (success: SuccessType) => {
    const areaCode = Store.get('areaCode')
    const code = areaCode ? `00${areaCode}` : ''
    const mobilePhone = `${code}${this.state.phoneNum}`
    const pwd = rsaEncodeString(mobilePhone + MD5(this.state.phoneNum))

    const {
      geetest_challenge: slideChallenge,
      geetest_seccode: slideSecCode,
      geetest_validate: slideValidate,
    } = success

    const params = {
      isSlideValidate: true,
      slideChallenge,
      slideSecCode,
      slideValidate,
      type: CaptEnum.FREE_LOGIN,
    }

    const res = await Login.sendVerCodeCaptcha({
      mobilePhone,
      requestType: '11',
      encryptCode: pwd,
      deviceId: MD5(this.state.phoneNum),
      queryTime: Date.now().toString(),
      ...params,
    })

    if (res.code !== 0) {
      global.$message(res.message)
      // 滑块验证异常
      if (+res.code === 100) {
        this.onCaptInit(null)
        return
      }
      this.captchaObj?.reset()
      return
    } else if (+res.returnCode !== 0) {
      global.$message(res.message, { variant: 'warning' })
      return
    }
    global.$message(res.message, { variant: 'success' })
    this.setState({ count: 59 })
  }

  // 图形验证码发送
  handlePassOk = async () => {
    const areaCode = Store.get('areaCode')
    const code = areaCode ? `00${areaCode}` : ''
    const mobilePhone = `${code}${this.state.phoneNum}`
    const pwd = rsaEncodeString(mobilePhone + MD5(this.state.phoneNum))
    const result = await Login.sendVerCodeCaptcha({
      mobilePhone,
      requestType: '11',
      encryptCode: pwd,
      validate: this.state.imgCaptcha.toUpperCase(),
      deviceId: MD5(this.state.phoneNum),
      queryTime: Date.now().toString(),
    })
    if (result.code === 0 && result.returnCode === '0') {
      this.setState({ count: 59 })
      global.$message(result.message, {
        variant: 'success',
      })
    } else {
      if (result.returnCode === '-13') {
        global.$message('验证码错误', { variant: 'success' })
      } else {
        global.$message(result.message, {
          variant: 'error',
        })
      }
    }
  }

  updateCount = () => {
    this.setState({ count: this.state.count - 1 })
  }

    // 下一步
    checkEnterpriseCode = async () => {
      const res = await Login.checkEnterpriseCode({
        customEnterpriseCode: this.state.enterpriseCode
      })

      if (res.code !== 0) {
        global.$message(res.message)
        return
      }
      this.setState({ stepOne: false, enterpriseAppId: res.body.appId })
    }

  // 获取验证码的时候调图形验证码
  phoneCaptchaImg = () => {
    this.setState({ imgVisible: true, imgCaptcha: '' }, this.onCaptchaImgLoad)
  }

  public render() {
    const { classes, AppStore, platformName,route } = this.props
    const {
      appListDialogVisible,
      loginLoading,
      dialogData,
      dialogVisible,
      isCancelLogin,
      isEnterpriseShow,
      loadingFirst,
      enterpriseMail,
      enterpriseWord,
      isPasswordType,
      imgVisible,
      ...rest
    } = this.state
    // 单纯隐藏一账通
    const hideOneLogin = route && route.indexOf('/project/learnCard') > -1
    const isButtonDisabled = (rest.loginType === LoginTabEnum.FREE_LOGIN && isPasswordType
      && (rest.username.length === 0 || rest.password.trim().length < 8))
      || (rest.loginType === LoginTabEnum.FREE_LOGIN && !isPasswordType
        && (rest.phoneNum.length === 0 || rest.captcha.trim().length === 0))
        || (rest.loginType === LoginTabEnum.NORMAL_LOGIN
          && (rest.username.length === 0 || rest.password.trim().length < 8))

    return (
      <>
        <Spin spinning={ loadingFirst } />
        <div className={classes.loginForm}>
          {isEnterpriseShow && <div className={classes.back} onClick={this.handleBack} />}
          {/* <div className={classes.switchLang}>
            <SwitchLanguage/>
          </div> */}
          <div className={classes.loginContainer}>
            <div>
              <div className={classes.hello}>HELLO</div>
              <div
                className={classes.welcome}
                // >欢迎使用{AppStore.theme.platformName}</div>
              >
                {!isEnterpriseShow ?
                  <span className={classes.welcomeTit}>
                    {transform('Login_welcome_use')}
                  </span> : <span className={classes.welcomeTit}>
                  企业账号登录
                  </span>}
                {!isEnterpriseShow && (platformName || AppStore.theme.platformName)}
              </div>
              <div className={classes.titleLine} />
            </div>
            {!isEnterpriseShow && <><LoginTab
              defaultValue={rest.loginType}
              onTabChnage={this.onTabChange}
            />
            <form
              className={classes.formContainer}
              noValidate={true}
              autoComplete="off"
            >
              {rest.loginType === LoginTabEnum.NORMAL_LOGIN && (
                <NormalLogin
                  username={rest.username}
                  password={rest.password}
                  rememberPwd={rest.rememberPwd}
                  usernameOrPwdError={rest.usernameOrPwdError}
                  captchaError={rest.captchaError}
                  captchaUrl={rest.captchaUrl}
                  onChange={this.onChange}
                  onCaptchaImgLoad={this.onCaptchaImgLoad}
                  appListDialogVisible={appListDialogVisible}
                  appList={dialogData}
                  dialogTitle={rest.dialogTitle}
                  onSelectApp={this.handleSelectApp}
                  onClose={this.closeAppListDialog}
                  loginLoading={loginLoading}
                  isCancelLogin={isCancelLogin}
                  resetLogin={this.resetLogin}
                />
              )}
              {rest.loginType === LoginTabEnum.FREE_LOGIN && !isPasswordType && (
                <FreeLogin
                  captchaObj={this.captchaObj}
                  phoneNum={rest.phoneNum}
                  visible={imgVisible}
                  identityCodeError={false}
                  count={this.state.count}
                  setVisible={(imgVisible) => {
                    this.setState({ imgVisible })
                  }}
                  setCount={(count) => {
                    this.setState({ count })
                  }}
                  phoneCaptchaImg={this.phoneCaptchaImg}
                  updateCount={this.updateCount}
                  onChange={this.onChange}
                  appListDialogVisible={appListDialogVisible}
                  appList={dialogData}
                  dialogTitle={rest.dialogTitle}
                  onSelectApp={this.onFreeLoginOrRegister}
                  onClose={this.closeAppListDialog}
                  loginLoading={loginLoading}
                  onCaptSuccess={this.onCaptSuccess}
                  onCaptInit={this.onCaptInit}
                  slideVisible={rest.slideVisible}
                  isCancelLogin={isCancelLogin}
                  resetLogin={this.resetLogin}
                  isPasswordType={this.state.isPasswordType}
                />
              )}
              {rest.loginType === LoginTabEnum.FREE_LOGIN && isPasswordType && (
                <PasswordLogin
                  username={rest.username}
                  password={rest.password}
                  usernameOrPwdError={rest.usernameOrPwdError}
                  identityCodeError={false}
                  onChange={this.onChange}
                  appListDialogVisible={appListDialogVisible}
                  appList={dialogData}
                  dialogTitle={rest.dialogTitle}
                  onSelectApp={this.handleSelectApp}
                  onClose={this.closeAppListDialog}
                  loginLoading={loginLoading}
                  isCancelLogin={isCancelLogin}
                  resetLogin={this.resetLogin}
                  isPasswordType={this.state.isPasswordType}
                />
              )}
              <LoginHelper
                isNormalLogin={rest.loginType === LoginTabEnum.NORMAL_LOGIN}
                rememberPwd={rest.rememberPwd}
                handleRememberPwdChange={this.handleRememberPwdChange}
                handlePwdForgot={this.onRoutePush('retrievePassword')}
                handleRegister={this.onRoutePush('register')}
                isPasswordType={this.state.isPasswordType}
                changeEmpLogin={this.changeEmpLogin}
              />
              <div style={{ position: 'relative' }}>
                <div>
                  <AdornedButton
                    variant="contained"
                    color="primary"
                    loading={(!appListDialogVisible || isCancelLogin) && loginLoading}
                    onClick={this.onLogin}
                    className={`${classes.loginButtonComp} ${
                      isButtonDisabled ? classes.btnDisabled : ''
                    }`}
                  >
                    登 录
                  </AdornedButton>
                </div>
                <div style={{ position: 'absolute', visibility: 'hidden', zIndex: -1 }}>
                  <SliderCaptcha
                    loginType={2}
                    onInit={this.onCaptInit}
                    onSuccess={this.onCaptSuccess}
                    type="202"
                  />
                </div>
              </div>
              {imgVisible && (
                <CaptchaImgDialog
                  captchaError={rest.captchaError}
                  captchaUrl={rest.captchaUrl}
                  captcha={this.state.imgCaptcha}
                  handleCaptchaChange={this.handleImgCaptchaChange}
                  handleUpdateCaptchaImg={this.onCaptchaImgLoad}
                  onClose={this.onImgClose}
                  captchaPass={this.captchaPass}
                />
              )}
              <AgreementForLogin
                handleAgree={(e, checkAgreement: boolean) => this.setState({ checkAgreement })}
                checkAgreement={rest.checkAgreement}
              />
              <ConfirmDialog
                visible={dialogVisible}
                confirmAndCancel={true}
                content={'您已登录PC直播端，在智门户登录后PC直播端将自动下线，请确认是否登录'}
                onOk={this.forceLogin}
                onCancel={this.handleCancel}
              />
              <div className={classes.loginOther}>
                {// 如果是从开放平台官网登录需要隐藏 企业登录方式
                  this.isOpenPlatformLogin ? null : (
                    <div className={classes.unionLogin} onClick={this.toEnterpriseLogin}>
                      <img src={enterpriseLogin} width="28" height="28" />
                      <div className="title">
                      企业账号登录
                      </div>
                    </div>
                  )}
              </div>
            </form>
            </>}
          </div>
          {isEnterpriseShow &&
          <div className={classes.loginContainer}>
            <LeftLogo
              AppStore={AppStore}
              coverImg={''}
            />
            <form
              className={classes.formContainer}
              noValidate={true}
              autoComplete="off"
            >
              {rest.loginType === LoginTabEnum.ENTERPRISE_LOGIN && (
                <EnterpriseLogin
                  enterpriseCode={rest?.enterpriseCode || ''}
                  enterpriseMail={enterpriseMail}
                  enterpriseWord={enterpriseWord}
                  stepOne={this.state.stepOne}
                  onChange={this.onChange}
                  onImgClose={this.onImgClose}
                  checkEnterpriseCode={this.checkEnterpriseCode}
                  handleCaptchaChange={this.handleImgCaptchaChange}
                  onCaptchaImgLoad={this.onCaptchaImgLoad}
                  appListDialogVisible={appListDialogVisible}
                  appList={dialogData}
                  dialogTitle={rest.dialogTitle}
                  onSelectApp={this.handleSelectApp}
                  onClose={this.closeAppListDialog}
                  loginLoading={loginLoading}
                  onCaptSuccess={this.onCaptSuccess}
                  onCaptInit={this.onCaptInit}
                  slideVisible={rest.slideVisible}
                  onEnterpriseLogin={this.onLogin}
                />)}
              {imgVisible && (
                <CaptchaImgDialog
                  captchaError={rest.captchaError}
                  captchaUrl={rest.captchaUrl}
                  captcha={this.state.imgCaptcha}
                  handleCaptchaChange={this.handleImgCaptchaChange}
                  handleUpdateCaptchaImg={this.onCaptchaImgLoad}
                  onClose={this.onImgClose}
                  captchaPass={this.captchaPass}
                />
              )}
            </form>
          </div> }
        </div>
      </>
    )
  }
  // 取消按钮
  private handleCancel = () => {
    this.setState({ dialogVisible: false, isCancelLogin: true })
    this.sliderParams = {} as SlideParamsType
  }
  // 确定强制登录
  private forceLogin = () => {
    const {
      loginType,
      captcha,
      imgCaptcha,
      forceLoginToken,
      username,
      password,
      isPasswordType
    } = this.state

    const userName = this.getFullUserName()
    const verCode = captcha.trim()
    const pwd = rsaEncodeString(username.trim() + ',pwd=' + password.trim())
    const initialPwd = Store.get('loginInfo', pwd)
    if (loginType === LoginTabEnum.FREE_LOGIN && !isPasswordType) {
      let type = CaptEnum.NORMAL_LOGIN as string
      if (this.isTopUpType) {
        type = '204'
      } else if (this.isOpenPlatformLogin) {
        type = '203'
      }
      const { appId } = Store.get('sessionInfo')
      const data = {
        userName,
        verCode,
        type,
        appId,
        forceKickOut: 1,
        forceLoginToken
      }
      Login.loginOrRegisterWithVerCode(data)
    } else {
      const appIdInfo = Store.get('appIdInfo')
      const loginInfo = isEqualFakePwd(password) ? initialPwd : pwd
      const validate = imgCaptcha.toUpperCase()
      const data = {
        appId: appIdInfo,
        validate,
        loginInfo,
        forceKickOut: 1,
        forceLoginToken,
        ...this.sliderParams,
      }
      Login.loginZhiNiao(data)
    }
    const { history, AppStore } = this.props
    getHomeList({ history, AppStore }, this.notHomeListType)
  }
  // 重置加载状态
  private resetLogin = () => {
    this.setState({
      isCancelLogin: false,
      loginLoading: false
    })
  }

  private onTabChange = (loginType: string) => {
    if (loginType === LoginTabEnum.FREE_LOGIN || (!this.state.rememberPwd && loginType === LoginTabEnum.NORMAL_LOGIN)) {
      this.setState({ password: '' })
    }
    this.setState({ loginType })
  }

  private toOneLogin = () => {
    const { checkAgreement } = this.state
    if (!checkAgreement) { // 未勾选服务协议不允许跳转
      global.$message('请阅读并同意隐私政策')
      return
    }
    const { href } = window.location
    const [_, query] = href.split('?')
    const urlQuery = query ? `?${query}` : ''
    this.props.history.push(`/one-login${urlQuery}`)
  }

  // 企业代码登录
  private toEnterpriseLogin = () => {
    const { checkAgreement } = this.state
    if (!checkAgreement) { // 未勾选服务协议不允许跳转
      global.$message('请阅读并同意隐私政策')
      return
    }
    this.setState({ loginType: LoginTabEnum.ENTERPRISE_LOGIN, isEnterpriseShow: true })
  }

  private closeAppListDialog = () => {
    this.setState(
      {
        appListDialogVisible: false,
        // '集团'
        dialogTitle: transform('Login_group'),
        dialogData: [],
        dialogType: 0,
      },
      this.onCaptchaImgLoad
    )
  }

  private handleSelectApp = (value: string) => async () => {
    if (this.state.dialogType) {
      const { dialogData } = this.state
      const item = dialogData.find(d => d.value === value)

      if (item) {
        UserStore.updateIdentity(value, item.title || '')
        const sessionInfo = Store.get('sessionInfo')
        Store.set('sessionInfo', {
          ...sessionInfo,
          enterpriseId: value,
          enterpriseName: item.title,
        })

        window.sessionStorage.setItem('__zn__sid', Store.get('sessionInfo').sid)

        const res = await Setting.enterpriseIsActive(
          sessionInfo.appId,
          sessionInfo.empId,
          value
        )
        const { code, body, message } = res
        if (code !== 0) {
          global.$message(message)
          return
        }
        if (+body.isSuccess === 1) {
          const res1 = await Login.sidIsEffective(sessionInfo.appId)
          if (res1.code !== 0) {
            global.$message(res1.message)
            return
          }
          if (
            res1.body.bodyCode === LoginBodyCodeEnum.VALID ||
            res1.body.bodyCode === LoginBodyCodeEnum.VALID_WITH_NOT_IDENTITY
          ) {
            const { enterpriseId, enterpriseName, sid, userId } = body
            const { history, AppStore } = this.props
            UserStore.updateLoginInfo(enterpriseId, enterpriseName, sid, userId)
            getHomeList({ history, AppStore }, this.notHomeListType)
          } else if (res1.body.bodyCode === LoginBodyCodeEnum.ACCOUNT_LOGIN_ANOTHER) {
            // 已经在PC直播端登录
            this.setState({ dialogVisible: true })
            return
          } else {
            global.$message(res1.body.bodyMsg)
          }
        }
      }
      return
    }
    this.doLogin(value)
  }

  private onLogin = async () => {
    const type = this.state.loginType
    const { isPasswordType, password, username, checkAgreement, enterpriseMail,
      enterpriseWord, isEnterpriseShow, ...rest } = this.state
    // 运营充值处理
    if (this.isTopUpType) {
      if (type === LoginTabEnum.FREE_LOGIN && !isPasswordType) {
        this.onFreeLoginOrRegister('com.mlearning.guangqichuanqi')()
        return
      }
      this.doLogin('com.mlearning.guangqichuanqi')
      return
    }

    if (!checkAgreement) {
      global.$message('请阅读并同意隐私政策')
      return
    }
    if (type === LoginTabEnum.FREE_LOGIN && !isPasswordType) {
      this.onFreeLogin()
      return
    } else {
      if ((type === LoginTabEnum.FREE_LOGIN && isPasswordType)
      || (isEnterpriseShow && type === LoginTabEnum.ENTERPRISE_LOGIN)
      || type === LoginTabEnum.NORMAL_LOGIN) {
        if (type === LoginTabEnum.FREE_LOGIN && isPasswordType && (!username.trim() || !password.trim())) {
          // '用户名和密码不能为空！'
          global.$message(transform('Login_username_pwd_empty'))
          return
        }
        if (isEnterpriseShow && type === LoginTabEnum.ENTERPRISE_LOGIN && (!enterpriseMail.trim() || !enterpriseWord.trim())) {
          global.$message('账号和密码不能为空！')
          return
        }
        if (type === LoginTabEnum.NORMAL_LOGIN  && !validateEmail(username)) {
          global.$message(transform('enter_true_email')) // 请填写正确的邮箱地址
          return
        }
        if (!this.captchaObj || !rest.slideVisible) {
          this.setState({ imgVisible: true, imgCaptcha: '' }, this.onCaptchaImgLoad)
          return
        }
        this.captchaObj.reset()
        const dom = document.getElementsByClassName('geetest_btn')[0] as HTMLElement
        dom?.click()
        return
      }
    }
  }

  private dealWithMultiApp = (appList: IAppItem[]) => {
    const dialogData = appList.map((app: IAppItem) => ({
      title: app.appName,
      value: app.appId,
    }))
    this.setState({
      appListDialogVisible: true,
      dialogData,
      loginLoading: false,
    })
  }
  private loginAppAndCompany = async () => {
    const { username, password, initialPwd, imgCaptcha, slideVisible } = this.state
    const { route = '' } = this.props

    if (!slideVisible && !imgCaptcha) {
      // '验证码不能为空！'
      global.$message(transform('Login_code_not_empty'))
      return
    }

    if (slideVisible && !this.sliderParams.isSlideValidate) {
      // '请完成滑块验证码校验！'
      global.$message(transform('Login_slider_verification'))
      return
    }

    const pwd = isEqualFakePwd(password)
      ? initialPwd
      : rsaEncodeString(password.trim())

    this.enhanceLoading(true)

    try {
      const result = await Login.loginAppAndCompany({
        userName: rsaEncodeString(username.trim()),
        password: pwd,
        validate: imgCaptcha.toUpperCase(),
        isOpenPlatform: this.isOpenPlatform,
        ...this.sliderParams,
      })
      if (+result.code !== 0) {

        this.onCaptchaImgLoad() // 验证码错误刷新
        global.$message(result.body ? result.body.bodyMsg : result.message)
        this.setState({ usernameOrPwdError: false, loginLoading: false })
        return
      }
      const { bodyCode, bodyMsg } = result.body
      let appList: any = []
      if (
        bodyCode === LoginBodyCodeEnum.VALID ||
        bodyCode === LoginBodyCodeEnum.VALID_WITH_NOT_IDENTITY
      ) {
        // 无企业身份登录
        appList = result.body.userAppArr || []
        const projectLearnCard = route.indexOf('/project/learnCard') > -1
        if (appList.length > 1 && !projectLearnCard) {
          this.dealWithMultiApp(appList)
        } else {
          let appId = appList[0] && appList[0].appId
          if (this.isOpenPlatformLogin && !appId) {
            appId = 'com.mlearning.guangqichuanqi'
          }
          this.doLogin(appId)
        }
        this.setState({ usernameOrPwdError: false, captchaError: false })
      } else {
        this.setState({ loginLoading: false })
        switch (bodyCode) {
        case LoginBodyCodeEnum.NO_IDENTITY_OR_NOT_VALID:
          if (result.body.bodyMsg.includes('密码')) {
            this.onCaptchaImgLoad() // 登录异常，刷新验证码
            global.$message(result.body ? result.body.bodyMsg : result.message)
            this.setState({
              captchaError: false,
            })
          } else {
            appList = result.body.userAppArr || []
            let appId = appList[0] && appList[0].appId
            if (this.isOpenPlatformLogin && !appId) {
              appId = 'com.mlearning.guangqichuanqi'
            }
            this.doLogin(appId) // 无企业身份登陆
            this.setState({ usernameOrPwdError: false, captchaError: false })
          }
          break
        case LoginBodyCodeEnum.VERIFICATION_CODE_ERROR:
          this.onCaptchaImgLoad() // 登录异常，刷新验证码
          this.setState({
            captchaError: true,
            usernameOrPwdError: false,
          })
          global.$message(bodyMsg)
          break
        case LoginBodyCodeEnum.SLIDE_CAPTCHA_ERR:
          this.onCaptchaImgLoad() // 登录异常，刷新验证码
          this.setState({ slideVisible: false })
          global.$message(bodyMsg)
          break
        case LoginBodyCodeEnum.ACCOUNT_LOGIN_ANOTHER:
          this.setState({ dialogVisible: true })
          break
        default:
          this.onCaptchaImgLoad() // 登录异常，刷新验证码e
          global.$message(bodyMsg)
        }
      }
    } catch (error) {
      global.$message('网络错误')
      this.setState({ usernameOrPwdError: false, loginLoading: false })
    }

  }

  private dealWithUnValid = (
    bodyCode: string,
    bodyMsg: string,
    userArr: IIdentytyItem[]
  ) => {
    this.setState(
      { loginLoading: false, appListDialogVisible: false },
      this.onCaptchaImgLoad
    )
    switch (bodyCode) {
    case LoginBodyCodeEnum.MULTI_IDENTITY:
      if (userArr.length) {
        const dialogData = userArr.map((item: IIdentytyItem) => ({
          title: item.enterpriseName,
          value: item.enterpriseId,
        }))
        this.setState({
          loginLoading: false,
          appListDialogVisible: true,
          // '身份'
          dialogTitle: transform('Login_identity'),
          dialogData,
          dialogType: 1,
        })
      }
      break
    default:
      global.$message(bodyMsg)
    }
  }

  // 企业代码登录
  private onEnterpriseLogin = async () => {
    const { enterpriseCode, enterpriseMail, enterpriseWord, imgCaptcha, slideVisible, enterpriseAppId } = this.state
    if (!slideVisible && !imgCaptcha) {
      // '验证码不能为空！'
      global.$message(transform('Login_code_not_empty'))
      return
    }

    if (slideVisible && !this.sliderParams.isSlideValidate) {
      // '请完成滑块验证码校验！'
      global.$message(transform('Login_slider_verification'))
      return
    }
    this.enhanceLoading(true)
    const pwd = rsaEncodeString(enterpriseWord.trim())
    const data = {
      customEnterpriseCode: enterpriseCode,
      empId: enterpriseMail,
      appId: enterpriseAppId,
      password: pwd,
      validate: imgCaptcha.toUpperCase(),
      ...this.sliderParams,
    }
    const res = await Login.enterpriseLogin(data)
    this.enhanceLoading(false)
    if (+res.code !== 0) {
      this.onCaptchaImgLoad()
      global.$message(res.message)
      return
    }
    const { bodyCode, bodyMsg, userArr = [], ...rest } = res.body
    const { history, AppStore } = this.props
    const sessionInfo = Store.get('sessionInfo')
    const id = rest.enterpriseId || sessionInfo?.enterpriseId || ''
    const name = rest.enterpriseName || sessionInfo?.enterpriseName || ''
    const loginSuccess =
      bodyCode === LoginBodyCodeEnum.VALID ||
      bodyCode === LoginBodyCodeEnum.VALID_WITH_NOT_IDENTITY
    if (loginSuccess) {
      UserStore.updateLoginInfo(id, name, rest.sid, rest.userId, enterpriseAppId)
      Store.set('mobilePhone', rest.mobilePhone)
      Store.set('enterpriseCode', enterpriseCode)
      setTimeout(() => {
        if (!this.notHomeListType) {
          queryOperationList()
        }
        getHomeList({ history, AppStore }, this.notHomeListType)
      })
      return
    }
    this.dealWithUnValid(bodyCode, bodyMsg, userArr)
  }

  private doLogin = async (appId: string) => {
    const { username, password, imgCaptcha, loginType } = this.state
    const { history, AppStore } = this.props
    const pwd = rsaEncodeString(username.trim() + ',pwd=' + password.trim())
    const initialPwd = Store.get('loginInfo', pwd)
    Store.set('appIdInfo', appId)
    this.enhanceLoading(true)
    const result = await Login.loginZhiNiao({
      appId,
      loginInfo: isEqualFakePwd(password) ? initialPwd : pwd,
      validate: imgCaptcha.toUpperCase(),
      ...this.sliderParams,
    })
    if (+result.code !== 0) {
      this.setState(
        { loginLoading: false, appListDialogVisible: false },
        this.onCaptchaImgLoad
      )
      global.$message(result.message)
      return
    }

    const { bodyCode, bodyMsg, userArr, forceLoginToken = '' } = result.body
    this.setState({ forceLoginToken })
    const loginSuccess =
      bodyCode === LoginBodyCodeEnum.VALID ||
      bodyCode === LoginBodyCodeEnum.VALID_WITH_NOT_IDENTITY
    if (loginSuccess) {
      if (loginType === LoginTabEnum.NORMAL_LOGIN) {
        this.state.rememberPwd ? rememberPwd(password, username) : deletePwd()
      }
      if (!this.notHomeListType) {
        queryOperationList()
      }
      getHomeList({ history, AppStore }, this.notHomeListType)
      return
    }
    // 已经在PC直播端登录
    const loginAnother = bodyCode === LoginBodyCodeEnum.ACCOUNT_LOGIN_ANOTHER
    if (loginAnother) {
      this.setState({ appListDialogVisible: false, dialogVisible: true })
      return
    }
    this.dealWithUnValid(bodyCode, bodyMsg, userArr)
  }

  private onRoutePush = (route: 'retrievePassword' | 'register') => () => {
    let routeUrl = this.isOpenPlatformLogin
      ? '?route=/admin/openPlatform/developer-auth'
      : ''
    if ((window.location.hash || '').includes('knowledge-cloud')) {
      routeUrl = `?route=${window.location.origin}/znWeb/knowledge-cloud/#/home`
    }
    const path = `/${route}${routeUrl}`
    this.props.history.push(path)
  }

  private onChange = (label: string, value: string) => {
    this.setState({ [label]: value })
  }

  private onCaptchaImgLoad = () => {
    const { isCancelLogin, username, phoneNum, loginType, isPasswordType, enterpriseMail } = this.state
    if (this.sliderParams.isSlideValidate || isCancelLogin) {
      this.sliderParams = {} as SlideParamsType
      this.captchaObj?.reset()
      return
    }
    const randomCode = Math.random().toString()
    let captchaNow = ''
    if (loginType === LoginTabEnum.FREE_LOGIN && !isPasswordType) {
      captchaNow = phoneNum
    } else if (loginType === LoginTabEnum.ENTERPRISE_LOGIN) {
      captchaNow = enterpriseMail
    } else {
      captchaNow = username
    }
    this.setState({
      captchaUrl: Login.getSafeImgCaptcha(captchaNow, randomCode),
    })
  }

  private handleRememberPwdChange = (event: any) => {
    this.setState({ rememberPwd: event.target.checked })
  }
  /**
   * 免密登录
   */
  private onFreeLogin = async () => {
    const { phoneNum, captcha, slideVisible, checkAgreement } = this.state
    const { route = '' }=this.props

    if (!phoneNum || !captcha) {
      // global.$message('手机号和验证码不能为空')
      global.$message(transform('Login_num_not_empty'))
      return
    }

    if (slideVisible && !this.sliderParams.isSlideValidate) {
      // '请完成滑块验证码校验！'
      global.$message(transform('Login_slider_verification'))
      return
    }
    if (!checkAgreement) {
      global.$message('请阅读并同意隐私政策')
      return
    }
    this.enhanceLoading(true)
    const userName = this.getFullUserName()
    const res1 = await Login.queryUserAppIdsWithVerCode({
      userName: rsaEncodeString(userName),
      verCode: rsaEncodeString(captcha.trim()),
      isOpenPlatform: '1',
    })
    const { userAppArr = [], bodyCode } = res1?.body || {}
    // 免密登录后台处理多身份返回列表有重复身份的脏数据，前端滤掉处理掉这种场景
    const appList = _.uniqBy(userAppArr as IAppItem[], 'appId')
    if (res1.code !== 0 || (!appList.length && !this.notHomeListType)) {
      const { bodyMsg } = res1?.body || {}
      this.enhanceLoading(false)
      if (bodyCode === LoginBodyCodeEnum.NO_IDENTITY_OR_NOT_VALID) {
        if (bodyMsg.includes('验证码')) {
          global.$message(bodyMsg)
          return
        }
        this.props.history.push('/noPermission/1')
      }
      if (bodyCode === LoginBodyCodeEnum.NO_PERMISSION) {
        global.$message(bodyMsg)
        return
      }
      if (
        bodyCode === LoginBodyCodeEnum.VALID ||
        bodyCode === LoginBodyCodeEnum.VALID_WITH_NOT_IDENTITY
      ) {
        let appId = appList[0] && appList[0].appId
        if (this.isOpenPlatformLogin && !appId) {
          appId = 'com.mlearning.guangqichuanqi'
        }
        this.onFreeLoginOrRegister(appId)()
      }
      this.onCaptchaImgLoad()
      return
    }
    const projectLearnCard=route.indexOf('/project/learnCard') > -1
    if (appList.length > 1 && !projectLearnCard) {
      this.dealWithMultiApp(appList)
      return
    }
    let appId = appList[0] && appList[0].appId
    if (this.isOpenPlatformLogin && !appId) {
      appId = 'com.mlearning.guangqichuanqi'
    }
    this.onFreeLoginOrRegister(appId)()
  }

  private enhanceLoading = (loginLoading: boolean) =>
    this.setState({ loginLoading })

  private getFullUserName = () => {
    const { loginType, phoneNum, username, isPasswordType } = this.state
    const area = Store.get('areaCode')
    let userName = phoneNum.trim()
    if (isPasswordType) {
      userName = username.trim()
    }
    if (loginType === LoginTabEnum.FREE_LOGIN && area && +area !== 86) {
      userName = area && `00${area}${userName}`
    }
    return userName
  }

  private onFreeLoginOrRegister = (value: string) => async () => {
    const { captcha, dialogType } = this.state
    const sessionInfo = Store.get('sessionInfo')
    const appId = dialogType ? sessionInfo.appId : value
    if (this.state.dialogType) {
      const { dialogData } = this.state
      const item = dialogData.find(d => d.value === value)

      if (item) {
        UserStore.updateIdentity(value, item.title || '')
        Store.set('sessionInfo', {
          ...sessionInfo,
          enterpriseId: value,
          enterpriseName: item.title,
          appId,
        })
        window.sessionStorage.setItem('__zn__sid', Store.get('sessionInfo').sid)
      }
    }

    let type = CaptEnum.NORMAL_LOGIN as string
    if (this.isTopUpType) {
      type = '204'
    } else if (this.isOpenPlatformLogin) {
      type = '203'
    }
    const userName = this.getFullUserName()
    const res2 = await Login.loginOrRegisterWithVerCode({
      verCode: captcha.trim(),
      userName,
      appId,
      type,
    })
    const { bodyCode, bodyMsg, userArr = [], forceLoginToken = '', ...rest } = res2.body
    const { history, AppStore } = this.props
    this.setState({ forceLoginToken })
    this.enhanceLoading(false)
    if (res2.code !== 0) {
      this.onCaptchaImgLoad()
      global.$message(res2.message)
      return
    }

    const id = rest.enterpriseId || sessionInfo?.enterpriseId || ''
    const name = rest.enterpriseName || sessionInfo?.enterpriseName || ''
    const loginSuccess =
      bodyCode === LoginBodyCodeEnum.VALID ||
      bodyCode === LoginBodyCodeEnum.VALID_WITH_NOT_IDENTITY
    if (loginSuccess) {
      UserStore.updateLoginInfo(id, name, rest.sid, rest.userId)
      Store.set('mobilePhone', rest.mobilePhone)
      setTimeout(() => {
        if (!this.notHomeListType) {
          queryOperationList()
        }
        getHomeList({ history, AppStore }, this.notHomeListType)
      })
      return
    }
    if (bodyCode === LoginBodyCodeEnum.ACCOUNT_LOGIN_ANOTHER) {
      // 已经在PC直播端登录
      this.setState({ appListDialogVisible: false, dialogVisible: true })
      return
    }
    this.dealWithUnValid(bodyCode, bodyMsg, userArr)
  }
}

export default withStyles(loginStyles)(LoginForm)
